import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.025 4.881a.75.75 0 0 0-.75.75V16.22h-1.43c-.751 0-1.128.888-.596 1.407l2.18 2.133a.857.857 0 0 0 1.192 0l2.18-2.133c.532-.52.155-1.407-.596-1.407h-1.43V5.63a.75.75 0 0 0-.75-.75M11 5.25a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5zm0 6a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5zM10.25 18a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }